import React from "react";
import "containers/ProjectCommon.css";
import AxiosConfig from "axiosConfig";
import ProgressStepper from "components/Project/ProgressStepper";
import ProjectBanner from "components/Project/ProjectBanner";
import InviteFriends from "components/Project/StartProject/Step_3/ImageFriends";
import FriendsInvitedGrid from "components/Project/StartProject/Step_3/FriendsInvitedGrid";
import UnregisteredFriendsInvite from "components/Project/StartProject/Step_3/UnregisteredFriendsInvite";
import TextArea from "components/General/Form/TextArea";
import FriendsSearchGrid from "components/Project/StartProject/Step_3/FriendsSearchGrid";
import TwoButtonLayout from "components/General/Form/CustomButton/TwoButtonLayout";
import TextTheme from "components/General/Text/TextTheme";
import * as FriendsSearchHelper from "components/Project/FriendsSearcHelper/FriendsSearchHelper";
import imageCompression from "browser-image-compression";
import Video from "components/General/Video/Video";
import ProjectOldInfo from "components/Project/Details/ProjectOldInfo";
import { validImages } from '../../../../../components/Spotlight/Album/ValidFiles';

class SpreadTheWord extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectSlug: this.props.match.params.slug,
      projectName: "",
      projectBanner: "",
      projectBadge: "",
      popupSearch: false,
      searchType: "",
      searchValue: "",
      searchMoreAvailable: true,
      searchLessAvailable: true,
      searchPage: 1,
      selectedFriends: new Map(),
      inviteMessage: "Hello Friends",
      unregisteredUser: [
        { email_address: "", issue: "" },
        { email_address: "", issue: "" },
        {
          email_address: "",
          issue: "",
        },
        { email_address: "", issue: "" },
        { email_address: "", issue: "" },
      ],
      unregisteredUserIssue: "",
      sendInvitationIssue: "",
      friendsSearchData: [],
      video: "",
      finalVideo: "",
      challengeSlug: this.props.location.state.challengeSlug,
      fileType: "",
      imagePopup: true,
      displayImagePopup: false,
      displayCustomPopup: false,
      displayCreationSuite: false,
      fileData: null,
      count: 1
    };
    this.openPopUp = this.openPopUp.bind(this);
    this.closePopUp = this.closePopUp.bind(this);
    this.popupControl = this.popupControl.bind(this);
    this.openCustomPopUp = this.openCustomPopUp.bind(this);
    this.fileUpload = this.fileUpload.bind(this);
    this.uploadApi = this.uploadApi.bind(this);
    this.openCreationSuite = this.openCreationSuite.bind(this);
    this.closeCreationSuite = this.closeCreationSuite.bind(this);
    this.handleCreationSuiteUpload = this.handleCreationSuiteUpload.bind(this);
  }

  openPopUp() {
    this.setState({
      displayImagePopup: true,
      count: 1
    })
    this.popupControl();
  }

  closePopUp() {
    this.setState({
      displayImagePopup: false,
      displayCustomPopup: false
    })
  }
  openCreationSuite() {
    this.setState({
      displayCreationSuite: true
    })
  }

  closeCreationSuite() {
    this.setState({
      displayCreationSuite: false,
      displayImagePopup: false,
      displayCustomPopup: false,
      fileData: null
    })
  }
  uploadApi() {
    const file = this.state.fileData;
    let form_data = new FormData();
    form_data.append("media", file);
    form_data.append("username", '');
    form_data.append("file_type", file.type);
    form_data.append("media_type", this.readMediaType(file.name));
    form_data.append("user_access", 'P');
    form_data.append("media_source", 'U');
    form_data.append("belongs_in", 'A');
    let album_form = form_data;
    album_form.append("belongs_in", 'C');

    AxiosConfig.post('mediaManager/media/', album_form, {//HTPP POST Request
      headers: {
        "content-type": "multipart/form-data",
      },
    }).then(res => {
      this.setState({
        displayCreationSuite: true
      })
    }).catch(err => {
    });

  }
  getExtension(file) {
    let ext = "";
    ext = file.split('.').pop();
    return ext;
  }
  readMediaType(file) {
    let ext = "";
    ext = this.getExtension(file);
    if (validImages().indexOf(ext) > -1) {
      return 'I';
    }
    else {
      return "";
    }
  }
  handleCreationSuiteUpload(val) {
    if (val) {
      const file = val;
      const fileType = file.type;
      const fileSize = file.size / 1024;
      const options = {
        maxSizeMB: 2,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      // const videoSize = file.size / 1024 / 1024;
      // if (videoSize > 2) {
      //   this.setState({
      //     errorMessage: "Video is too big in size. Maximum 2MB is accepted",
      //   });
      // } else {
      if (fileType.includes("image")) {
        if (fileSize > 2000) {
          if (fileType.includes("gif")) {
            this.setState({
              video: "",
              userProjectVideo: "",
              errorMessage:
                "Uploaded photo is too big in size. Maximum 2MB accepted for GIFs.",
              fileType: "",
            });
          } else {
            imageCompression(file, options)
              .then((compressedFile) => {
                this.setState({
                  video: URL.createObjectURL(compressedFile),
                  userProjectVideo: compressedFile,
                  errorMessage: "",
                  fileType: "image",
                  imagePopup: false
                });
              })
              .catch((error) => { });
          }
        } else {
          this.setState({
            video: URL.createObjectURL(file),
            userProjectVideo: file,
            errorMessage: "",
            fileType: "image",
            imagePopup: false
          });
        }
      } else if (fileType.includes("video")) {
        this.setState({
          video: URL.createObjectURL(file),
          userProjectVideo: file,
          errorMessage: "",
          fileType: "video",
          imagePopup: false
        });
      } else {
        this.setState({
          video: "",
          userProjectVideo: "",
          errorMessage: "Please upload a video or photo.",
          fileType: "",
        });
      }
    }
  }

  fileUpload() {
    const file = this.state.fileData;
    const fileType = file.type;
    const fileSize = file.size / 1024;
    const options = {
      maxSizeMB: 2,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    if (fileSize > 2000) {
      if (fileType.includes("gif")) {
        this.setState({
          video: "",
          userProjectVideo: "",
          errorMessage:
            "Uploaded photo is too big in size. Maximum 2MB accepted for GIFs.",
          fileType: "",
        });
      } else {
        imageCompression(file, options)
          .then((compressedFile) => {
            this.setState({
              video: URL.createObjectURL(compressedFile),
              userProjectVideo: compressedFile,
              errorMessage: "",
              fileType: "image",
              imagePopup: false,
              displayCustomPopup: false,
              displayImagePopup: false
            });
          })
          .catch((error) => { });
      }
    } else {
      this.setState({
        video: URL.createObjectURL(file),
        userProjectVideo: file,
        errorMessage: "",
        fileType: "image",
        imagePopup: false,
        displayCustomPopup: false,
        displayImagePopup: false
      });
    }
  }
  popupControl() {
    this.setState({
      imagePopup: true
    })
  }
  openCustomPopUp(file) {
    this.setState({
      displayImagePopup: false,
      displayCustomPopup: true,
      fileData: file,
      count: 2,
    })
  }
  componentDidMount() {
    const projectSlug = this.props.match.params.slug;
    window.onpopstate = (e) => {
      this.onBackButtonEvent();
    };
    AxiosConfig.get(`/impactprojects/project/${projectSlug}/`)
      .then((res) => {
        this.setState({
          projectName: res.data.name,
          projectBanner: res.data.banner,
          projectBadge: res.data.badge,
        });
      })
      .catch();
  }
  onBackButtonEvent = () => {
    this.props.history.push({
      pathname: `/projects/`,
    });
  };
  videoHandler = (event) => {
    if (event.target.files[0]) {
      const file = event.target.files[0];
      const fileType = file.type;
      const fileSize = file.size / 1024;
      const options = {
        maxSizeMB: 2,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      };
      // const videoSize = event.target.files[0].size / 1024 / 1024;
      // if (videoSize > 2) {
      //   this.setState({
      //     sendInvitationIssue: "Video is large in size. Maximum 2MB accepted.",
      //   });
      // } else {}
      if (fileType.includes("image")) {
         this.openCustomPopUp(file);
      } else if (fileType.includes("video")) {
        this.setState({
          video: URL.createObjectURL(file),
          finalVideo: file,
          sendInvitationIssue: "",
          fileType: "video",
          imagePopup: false
        });
      } else {
        // this.setState({
        //   video: "",
        //   finalVideo: "",
        //   sendInvitationIssue:
        //     "Please upload a video or photo for your invitees.",
        //   fileType: "",
        // });
      }
    }
  };

  sendInvitationToUsers(obj, action_type) {
    let form_data = new FormData();

    for (const friends of this.state.selectedFriends.values()) {
      form_data.append("registered_user", friends["user_email"]);
    }
    for (let i = 0; i < this.state.unregisteredUser.length; i++) {
      form_data.append(
        "unregistered_user",
        this.state.unregisteredUser[i]["email_address"].trim()
      );
    }
    form_data.append("project", this.state.projectSlug);
    form_data.append("invitation_message", this.state.inviteMessage);
    form_data.append("challenge", this.state.challengeSlug);
    form_data.append("video", this.state.finalVideo||'');
    form_data.append("projectUserId", this.props.location.state.projectUserId);
    AxiosConfig.post(`/impactprojects/spread_the_word/`, form_data)
      .then((response) => {
        if (action_type.toString().toLowerCase() === "done") {
          this.props.history.push({
            pathname: `/projects/${this.state.projectSlug}/congratulations`,
            state: {
              adventureId: this.props.location.state.adventureId,
              adventureSlug: this.props.location.state.adventureSlug,
              challengeSlug: this.props.location.state.challengeSlug,
              projectUserId: this.props.location.state.projectUserId,
            },
          });
        } else {
          this.props.history.push("/projects/");
        }
      })
      .catch(function (error) {
      });
  }

  checkInvitationMessageErr() {
    if (this.state.video.length === 0) {
      this.setState({
        sendInvitationIssue:
          "Please upload a video or photo for your invitees.",
      });
      return true;
    } else if (this.state.inviteMessage.length === 0) {
      this.setState({
        sendInvitationIssue:
          "Enter an Invitation message to be sent to your invitees.",
      });
      return true;
    }
    return false;
  }

  checkUnregisteredUsersErr() {
    let errorFlag = false;
    for (let i = 0; i < this.state.unregisteredUser.length; i++) {
      if (this.state.unregisteredUser[i]["issue"].trim().length !== 0) {
        errorFlag = true;
        // this.setState({ unregisteredUser: this.state.unregisteredUser });
        this.setState({
          sendInvitationIssue: "Invalid Email Id of Unregistered User.",
        });
        break;
      }
    }
    return errorFlag;
  }

  /*
    This method will actually call the backend API and fetch the friends result based on the search query
     */
  fetchFriendsData(obj, searchType, searchValue, page, searchMoreFlag) {
    FriendsSearchHelper.fetchFriendsDataHelper(
      obj,
      searchType,
      searchValue,
      page,
      searchMoreFlag
    );
  }

  // button actions

  sendInviteButtonClick(event, action_type) {
    // this.checkFriendsSelected();
    if (
      (this.checkUnregisteredUsersErr() === false ||
      this.checkFriendsSelected() === false ) &&
      this.checkInvitationMessageErr() === false
    ) {
      this.setState({ sendInvitationIssue: "" });
      this.sendInvitationToUsers(this, action_type);
    } else {
      this.setState({
        sendInvitationIssue:
          "Select atleast one friend to spread the word and upload a video or photo along with a message to send to your invitees",
      });
    }
  }
  checkFriendsSelected() {
    if (this.state.selectedFriends.size <= 0) {
      return true;
    } else {
      return false;
    }
  }
  render() {
    return (
      <div className="header_main">
        {this.state.popupSearch ? (
          <FriendsSearchGrid
            searchData={this.state.friendsSearchData}
            searchStringType={this.state.searchType}
            searchStringValue={this.state.searchValue}
            searchMore={this.state.searchMoreAvailable}
            searchLess={this.state.searchLessAvailable}
            searchResultCancelClick={FriendsSearchHelper.searchResultCancelClick.bind(
              this
            )}
            searchResultDoneClick={FriendsSearchHelper.searchResultDoneClick.bind(
              this
            )}
            searchResultNextClick={FriendsSearchHelper.searchResultNextClick.bind(
              this
            )}
            searchResultBackClick={FriendsSearchHelper.searchResultBackClick.bind(
              this
            )}
            searchResultImageClick={FriendsSearchHelper.searchResultImageClick.bind(
              this
            )}
          />
        ) : null}
        <div className="page_main">
          <div className="page_info_vr_content_main">
            <ProjectOldInfo
              vertical={true}
              project={this.props.match.params.slug}
            />
          </div>

          <div className="page_details_main">
            <div className="project-banner">
              <ProjectBanner image={this.state.projectBanner} />
            </div>
            <div className="page_info_hr_content_main">
              <ProjectOldInfo
                project={this.props.match.params.slug}
                showChallengeDetails={true}
              />
            </div>
            <div className="page_details_content_main border-0">
              <div className="stepper_main_content">
                <ProgressStepper
                  currentStep="4"
                  challengeSlug={this.props.location.state.challengeSlug}
                  goalDate={this.props.location.state.goalDate}
                  adventureId={this.props.location.state.adventureId}
                  projectSlug={this.props.location.state.projectSlug}
                  adventureSlug={this.props.location.state.adventureSlug}
                  isInvite={this.props.location.state.isInvite}
                  email={this.props.location.state.email}
                  invitationId={this.props.location.state.invitationId}
                  projectUserId={this.props.location.state.projectUserId}
                  showStepper={this.props.location.state.showStepper}
                />
              </div>
            </div>
            <div className="page_details_content_main">
              <div className="project-details">
                <div className="insideContent">
                  {this.props.location.state.isInvite ? (
                    <h3 className="textHeader">STEP 2 : MAKE AN IMPACT</h3>
                  ) : (
                    <h3 className="textHeader">STEP 5 : MAKE AN IMPACT</h3>
                  )}
                </div>
              </div>
              <TextTheme
                message="SPREAD THE WORD"
                className="mt-15 text_medium aboutMeTitle text_semi_bold d-inline-block mb-15"
              />
              <TextTheme
                message="Spread the word by inviting your family and friends to join you on your project."
                className="text_medium text_black"
              />
              <div className="share-story">
                <TextTheme
                  message="1. Create a Personal Video to :"
                  className="mt-15 text_small text_black"
                />
                <ul>
                  <li>
                    <TextTheme
                      message="Explain why you choose this project."
                      className="text_small text_black"
                    />
                  </li>
                  <li>
                    <TextTheme
                      message="Explain why people should support the project."
                      className="text_small text_black"
                    />
                  </li>
                  <li>
                    <TextTheme
                      message="Ask your family and friends to join your project."
                      className="text_small text_black"
                    />
                  </li>
                </ul>
              </div>
              <div className="d-inline-block w-100 mb-15">
                <Video
                  src={this.state.video}
                  id="file"
                  style={{ display: "none" }}
                  type="file"
                  name="video"
                  accept="video/*"
                  width="100%"
                  onChange={this.videoHandler.bind(this)}
                  fileType={this.state.fileType}
                  count={this.state.count}
                  fileData={this.state.fileData}
                  displayCustomPopup={this.state.displayCustomPopup}
                  displayImagePopup={this.state.displayImagePopup}
                  displayCreationSuite={this.state.displayCreationSuite}
                  closePopUp={this.closePopUp}
                  openPopUp={this.openPopUp}
                  imagePopup={this.state.imagePopup}
                  popupControl={this.popupControl}
                  fileUpload={this.fileUpload}
                  uploadApi={this.uploadApi}
                  openCreationSuite={this.openCreationSuite}
                  closeCreationSuite={this.closeCreationSuite}
                  handleCreationSuiteUpload={this.handleCreationSuiteUpload}
                />
              </div>
              <InviteFriends
                message="2. Invite family and friends to join the project."
                searchResultHandler={FriendsSearchHelper.searchResultHandler.bind(
                  this
                )}
                disabled={this.state.popupSearch}
              />
              <div className="mt-15 mb-15">
                <FriendsInvitedGrid
                  friendsInvitedData={[...this.state.selectedFriends.values()]}
                  removeInviteClick={FriendsSearchHelper.removeInviteClick.bind(
                    this
                  )}
                />
              </div>
              <div>
                <UnregisteredFriendsInvite
                  message="3. Send invites to unregistered users."
                  unregisteredUser={this.state.unregisteredUser}
                  unregisteredUserIssue={this.state.unregisteredUserIssue}
                  unregisteredUserAddMoreClick={FriendsSearchHelper.unregisteredUserAddMore.bind(
                    this
                  )}
                  unregisteredUserEmailChange={FriendsSearchHelper.unregisteredUserEmailChange.bind(
                    this
                  )}
                  unregisteredUserDeleteClick={FriendsSearchHelper.unregisteredUserDeleteClick.bind(
                    this
                  )}
                  unregisteredUserEmailValidate={FriendsSearchHelper.unregisteredUserEmailValidate.bind(
                    this
                  )}
                />
              </div>
              <div className="d-inline-block w-100 mt-15">
                <TextTheme
                  message="4. Invitation message to friends."
                  className="mt-15 text_small text_black"
                />
                <TextArea
                  value={this.state.inviteMessage}
                  rows={5}
                  handleChange={FriendsSearchHelper.inviteMessageChange.bind(
                    this
                  )}
                />
              </div>
              <TextTheme
                message={this.state.sendInvitationIssue}
                className="text_small text_red mt-15 mb-15"
              />
              <TwoButtonLayout
                style={{ justifyContent: "flex-end" }}
                button1Text="SAVE"
                button2Text="COMPLETE PROJECT"
                button1Click={(event) =>
                  this.sendInviteButtonClick(event, "save")
                }
                button2Click={(event) =>
                  this.sendInviteButtonClick(event, "done")
                }
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SpreadTheWord;
